import { countries as c } from "countries-list";
import { TranslateFunction } from "react-localize-redux";

interface CountryOption {
  countryCode: string;
  name: string;
}

const displayNamesCache = new Map<string, Intl.DisplayNames>();

function getDisplayNames(locale: string): Intl.DisplayNames | undefined {
  if (typeof Intl.DisplayNames === "undefined") {
    return undefined;
  }

  const displayNames = displayNamesCache.get(locale);
  if (!displayNames) {
    const newDisplayNames = new Intl.DisplayNames([locale], { type: "region" });
    displayNamesCache.set(locale, newDisplayNames);

    return newDisplayNames;
  }
  return displayNames;
}

export function getSortedCountryCodesAndNames(locale: string, translate: TranslateFunction): CountryOption[] {
  const allCountryCodes = Object.keys(c);

  const displayNames = getDisplayNames(locale);
  const entries = Object.entries(c);

  const countryCodesWithNames = allCountryCodes.map((countryCode) => {
    const entry = entries.find(([cc]) => cc === countryCode);

    const name = 
      displayNames?.of(countryCode) ?? entry?.[1].name ?? (translate("countries.countryNotFound") as string)
    return { countryCode, name };
  });

  return countryCodesWithNames.sort((a, b) => a.name.localeCompare(b.name));
}
